<script setup lang="ts">
/**
 * Footer V2 — SessionInfo
 *
 * Linha exibida acima do accordion "Atalho" quando o usuário está logado:
 *   "Tempo logado: 55m 52s"        "Último login: 14/03/2025, 17:15"
 *
 * Fontes de dados (sem duplicar lógica):
 *   - timeLoggedIn: já incrementado globalmente em components/user/header/InfosBar.vue
 *     via setInterval no useUserActivityStore.
 *   - userLastLogin: composable useUserData() (mapeia user.last_login do payload de login).
 *
 * Tokens (Figma):
 *   container: display flex; width 100%; justify-content: space-between; align-items: center;
 *   texto: Plus Jakarta Sans 12/16 weight 400, color #FFF.
 */

const { isAuthenticated } = storeToRefs(useAuthStore());
const { timeLoggedIn } = storeToRefs(useUserActivityStore());
const { userLastLogin } = useUserData();

// formatTime/formatWithLeadingZero vêm de utils/format-time.ts
// (auto-imported), evitando duplicação com components/user/header/InfosBar.vue.

const formattedTimeLoggedIn = computed(() => formatTime(timeLoggedIn.value));

const formattedLastLogin = computed(() => {
  if (!userLastLogin.value) return null;

  const date = new Date(userLastLogin.value);

  if (Number.isNaN(date.getTime())) return null;

  return date.toLocaleString('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  });
});
</script>

<template>
  <div
    v-if="isAuthenticated"
    class="footer-v2-session-info"
    data-testid="footer-v2-session-info"
  >
    <span class="footer-v2-session-info__item">
      Tempo logado: {{ formattedTimeLoggedIn }}
    </span>

    <span
      v-if="formattedLastLogin"
      class="footer-v2-session-info__item"
    >
      Último login: {{ formattedLastLogin }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.footer-v2-session-info {
  @apply w-full flex justify-between items-center;
  padding: 0;

  &__item {
    color: #fff;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }
}
</style>
